import { AppRoutes } from "AppRoutes";
import { usePermissions } from "providers";
import { useTranslations } from "providers";

import { SbbPersona, SbbPersonaProps } from "./SbbPersona";

interface SbbPersonaLinkProps extends SbbPersonaProps {
  hideUrl?: boolean;
}

export const SbbPersonaLink: React.FC<SbbPersonaLinkProps> = ({ hideUrl = false, ...otherProps }) => {
  const i18n = useTranslations();
  const { isAdministrator } = usePermissions();
  if (isAdministrator && !hideUrl) {
    return (
      <a
        href="#"
        onClick={() => (window.location.href = AppRoutes.toUser(otherProps.personnelNumber))}
        className="ms-Persona-url global-tooltip-trigger"
        title={i18n.Actions_OpenUserProfile}
      >
        <SbbPersona {...otherProps} />
      </a>
    );
  } else {
    return <SbbPersona {...otherProps} />;
  }
};
